import { Form, Button, Row, Col, Table, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState } from 'react';
import { setIsLoading } from '../general/actions';
import { currencyFormater, downloadExcel } from '../general/utils';
import SelectAgreement from '../general/selectAgreement';

const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const YEARS = Array.from({ length: 2050 - 2023 }, (_, i) => 2023 + i);

function MonthlyReport(props) {
    const { setIsLoading } = props;

    const [funds, setFunds] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [agreementFilter, setAgreementFilter] = useState();
    const [rounded, setRounded] = useState(localStorage.rounded === 'true');
    const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
    const [monthFilter, setMonthFilter] = useState(new Date().getMonth());
    const [amountTotal, setAmountTotal] = useState(0);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');

    useEffect(() => { localStorage.rounded = rounded || false; }, [rounded]);

    useEffect(() => {
        if (agreementFilter) {
            setSearchText('');
            getFunds();
        } else {
            setFunds([]);
            setMessageType('info');
            setMessage('Selecciona un contrato para ver el reporte');
        }
    }, [agreementFilter, yearFilter, monthFilter]);

    useEffect(() => {
        setAmountTotal(funds.reduce((acc, f) => acc + parseFloat(f.total_amount), 0));
    }, [funds]);

    const getFunds = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('/reports/monthly/' + agreementFilter, {
                params: { year: yearFilter, month: parseInt(monthFilter) + 1 },
            });
            setFunds(response.data);
            if (response.data.length) {
                setMessage('');
            } else {
                setMessageType('warning');
                setMessage('El contrato seleccionado no tiene pedidos en el periodo seleccionado');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const formatAmount = (val) => currencyFormater(parseFloat(val), rounded);

    return (
        <>
            {/* ── Ayuda ── */}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, background: 'rgba(37,99,235,0.05)', border: '1px solid rgba(37,99,235,0.15)', borderRadius: 12, padding: '12px 16px', marginBottom: 14 }}>
                <i className="fa fa-lightbulb-o" style={{ color: 'var(--abi-primary)', fontSize: 18, marginTop: 2, flexShrink: 0 }} />
                <div style={{ fontSize: 13, color: 'var(--abi-text)', lineHeight: 1.65 }}>
                    <strong>Consolidado Mensual:</strong> agrupa el consumo por producto dentro del mes y contrato seleccionados.
                    Muestra cuántos pedidos incluyeron cada producto, la cantidad total y el valor acumulado —
                    ideal para actas de cobro y validación de facturación mensual.
                    Activa <strong>Redondear valores</strong> para obtener cifras sin decimales en la exportación.
                </div>
            </div>

            {/* ── Panel de filtros ── */}
            <div className="order-section">
                <div className="order-section-header">
                    <i className="fa fa-bar-chart" /> Reporte Consolidado Mensual
                </div>
                <div className="order-section-body">
                    <Row className="g-3 align-items-end">
                        <Col md={2} xs={6}>
                            <Form.Group>
                                <Form.Label className="report-field-label">Año</Form.Label>
                                <Form.Select value={yearFilter} onChange={(e) => setYearFilter(e.target.value)}>
                                    {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Group>
                                <Form.Label className="report-field-label">Mes</Form.Label>
                                <Form.Select value={monthFilter} onChange={(e) => setMonthFilter(e.target.value)}>
                                    {MONTHS.map((m, i) => <option key={m} value={i}>{m}</option>)}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6} xs={12}>
                            <Form.Label className="report-field-label">Contrato</Form.Label>
                            <SelectAgreement agreement={agreementFilter} setAgreement={setAgreementFilter} disabled={false} />
                        </Col>
                        <Col md={2} xs={12} className="d-flex align-items-end pb-1">
                            <Form.Check
                                type="switch" id="rounded-switch"
                                label="Redondear valores"
                                checked={rounded}
                                onChange={(e) => setRounded(e.target.checked)}
                                style={{ fontSize: 13 }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>

            {message && <Alert variant={messageType || 'warning'} className="mt-2">{message}</Alert>}

            {funds.length > 0 && (
                <>
                    <div className="report-toolbar">
                        <span className="report-count">
                            <strong>{funds.length}</strong> línea{funds.length !== 1 ? 's' : ''} —{' '}
                            <strong>{MONTHS[monthFilter]} {yearFilter}</strong>
                        </span>
                        <div className="d-flex gap-2">
                            <Button variant="outline-success" size="sm" onClick={() => {
                                const headers = ['Centro de Costos', 'ID Fondo', 'Ext ID Fondo', 'Nombre Fondo', 'ID Producto', 'Ext ID Producto', 'Producto', 'Pedidos', 'Cantidad', 'Total'];
                                const rows = funds.map(f => [
                                    `${f.department_id}: ${f.department}`,
                                    f.fund_id,
                                    f.fund_ext_id,
                                    f.fund_name,
                                    f.product_id,
                                    f.product_ext_id,
                                    f.product,
                                    f.orders,
                                    f.quantity,
                                    parseFloat(f.total_amount),
                                ]);
                                downloadExcel(headers, rows, `Reporte mensual ${MONTHS[monthFilter]} ${yearFilter}`, 'Mensual');
                            }}>
                                <i className="fa fa-file-excel-o" /> Excel
                            </Button>
                            <Button variant="outline-primary" size="sm" title="Actualizar" onClick={getFunds}>
                                <i className="fa fa-rotate-right" />
                            </Button>
                        </div>
                    </div>

                    <Table responsive className="report-table" id="funds">
                        <thead>
                            <tr>
                                <th>Centro de Costos</th>
                                <th>Fondo</th>
                                <th>Nombre Fondo</th>
                                <th>Producto</th>
                                <th>Nombre Producto</th>
                                <th>Pedidos</th>
                                <th>Precio Un. sin IVA</th>
                                <th>IVA</th>
                                <th>Cantidad</th>
                                <th className="text-end">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {funds.map(item => (
                                <tr key={'monthly-' + item.product_id + '-' + item.orders}>
                                    <td style={{ fontSize: 13 }}>
                                        <span style={{ fontWeight: 600 }}>{item.department_id}</span>
                                        <span style={{ color: 'var(--abi-muted)' }}>: {item.department}</span>
                                    </td>
                                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{item.fund_id}:{item.fund_ext_id}</td>
                                    <td style={{ fontWeight: 600, fontSize: 13 }}>{item.fund_name}</td>
                                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>
                                        {item.product_id}: {item.product_ext_id}
                                    </td>
                                    <td style={{ fontSize: 13 }}>{item.product}</td>
                                    <td className="text-center" style={{ fontWeight: 600 }}>{item.orders}</td>
                                    <td className="text-center">{formatAmount(parseFloat(item.price))}</td>
                                    <td className="text-center">{item.taxes}</td>
                                    <td className="text-center">{item.quantity}</td>
                                    <td className="text-end" style={{ fontWeight: 700 }}>
                                        {formatAmount(item.total_amount)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="report-tfoot">
                                <th colSpan={9}>Total {MONTHS[monthFilter]} {yearFilter}</th>
                                <th className="text-end" style={{ fontSize: 15 }}>
                                    {formatAmount(amountTotal)}
                                </th>
                            </tr>
                        </tfoot>
                    </Table>
                </>
            )}
        </>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyReport);
